import http, { AUTH_ROUTES } from '../../../services/api';
import { errorNotifier, successNotifier } from '../../../components/NotificationHandler';

export const getCableSubscription = async (userId, provider) => {
  try {
    const {
      data: { result },
    } = await http.get(AUTH_ROUTES.GET_CABLE_SUBSCRIPTION(userId, provider));

    if (result?.success && result?.data?.data) {
      // Transform the data to match the expected format
      const transformedData = result.data.data.map(item => ({
        _id: item.variation_id.toString(),
        name: item.package_bouquet,
        planAmount: item.price,
        companyAmount: item.price,
        serviceId: item.service_id,
        serviceName: item.service_name,
        availability: item.availability
      }));
      return transformedData;
    }
    return [];
  } catch (e) {
    console.error('Error fetching cable subscription:', e);
    return [];
  }
};

export const updateSubscriptionPrice = async (payload, setLoading) => {
  setLoading(true);
  try {
    const { data } = await http.post(AUTH_ROUTES.UPDATE_SUBSCRIPTION_PRICE, payload);
    successNotifier(data?.message || 'Price updated successfully');
  } catch (e) {
    errorNotifier(e.response?.data?.message || 'Failed to update price');
  } finally {
    setLoading(false);
  }
};

export const updateDataSubscription = async (item, setLoading) => {
  const payload = {
    type: 'data',
    variationId: item._id,
    service: item.serviceId,
    serviceId: item.serviceId,
    plan: item.name,
    price: item.planAmount,
    companyPrice: item.companyAmount
  };
  await updateSubscriptionPrice(payload, setLoading);
};

export const updateCableSubscription = async (item, setLoading) => {
  const payload = {
    type: 'cable',
    variationId: item._id,
    service: item.serviceId,
    serviceId: item.serviceId,
    plan: item.name,
    price: item.planAmount,
    companyPrice: item.companyAmount
  };
  await updateSubscriptionPrice(payload, setLoading);
};

export const updateEnergySubscription = async (item, setLoading) => {
  const payload = {
    type: 'electricty',
    variationId: item.variationId,
    service: item.serviceId,
    serviceId: item.serviceId,
    plan: item.plan,
    price: item.amount,
    companyPrice: item.companyAmount
  };
  await updateSubscriptionPrice(payload, setLoading);
};

export const getEstateInfo = async (userId, setEstateInfo) => {
  try {
    const {
      data: {
        result: { data },
      },
    } = await http.get(AUTH_ROUTES.GET_ESTATE_INFO(userId));
    setEstateInfo(data);
  } catch (e) {
    // errorNotifier(e.response?.data?.result);
    // setEstateInfo(data);
  }
};

export const changeEstateInfo = async (payload, setEstateDetailsLoading) => {
  try {
    await http.post(AUTH_ROUTES.CHANGE_ESTATE_INFO, payload);
    successNotifier('Estate details saved successfully');
    setEstateDetailsLoading(false);
  } catch (e) {
    errorNotifier(e.response?.data?.result);
    setEstateDetailsLoading(false);
  }
};

export const getEnergySubscription = async (setLoading) => {
  try {
    setLoading(true);
    const {
      data: { result },
    } = await http.get(AUTH_ROUTES.GET_ENERGY_SUBSCRIPTION());

    if (result?.success && result?.data) {
      // Transform the data to match the expected format
      const transformedData = result.data.map(item => ({
        _id: item._id,
        discoName: item.service.replace(/-/g, ' ').toUpperCase(),
        amount: item.price,
        companyAmount: item.companyPrice,
        plan: item.plan,
        serviceId: item.serviceId,
        variationId: item.variationId,
        type: item.type
      }));
      return transformedData;
    }
    return [];
  } catch (e) {
    console.error('Error fetching energy subscription:', e);
    return [];
  } finally {
    setLoading(false);
  }
};

export const getDataSubscription = async (userId, network) => {
  try {
    const {
      data: { result },
    } = await http.get(AUTH_ROUTES.GET_DATA_SUBSCRIPTION(userId, network));
    
    if (result?.success && result?.data?.data) {
      // Transform the data to match the expected format
      const transformedData = result.data.data.map(item => ({
        _id: item.variation_id.toString(),
        name: item.data_plan,
        planAmount: item.price,
        companyAmount: item.price,
        serviceId: item.service_id,
        serviceName: item.service_name,
        availability: item.availability
      }));
      return transformedData;
    }
    return [];
  } catch (e) {
    console.error('Error fetching data subscription:', e);
    return [];
  }
};

export const syncDataPlans = async (userId, setLoading) => {
  setLoading(true);
  try {
    const { data } = await http.get(AUTH_ROUTES.SYNC_DATA_PLAN(userId));

    successNotifier(data?.message);
  } catch (e) {
    errorNotifier(e.response.data.message);
  } finally {
    setLoading(false);
  }
};
